import { render, staticRenderFns } from "./SummaryBoard.vue?vue&type=template&id=23377358&scoped=true&"
import script from "./SummaryBoard.vue?vue&type=script&lang=js&"
export * from "./SummaryBoard.vue?vue&type=script&lang=js&"
import style0 from "./SummaryBoard.vue?vue&type=style&index=0&id=23377358&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23377358",
  null
  
)

export default component.exports